import { DistributionSendFromApi } from '../../../api/distributions/model/distribution-api.model';
import { EmailAccountConnectorMessageApi } from '../../../api/targeting/model/email-account-connector-message-api';

export class EmailAccountConnectorMessageModel {
    subjectLine: string;
    previewText: string;
    fromName: string;
    replyTo: string;
    replyMessageId: string;
    bodyHtml: string = '';
    bodyPlainText: string;
    sendFrom: DistributionSendFromApi;

    // f/e use only
    fromEmail: string;
    toName: string;

    constructor(apiModel?: EmailAccountConnectorMessageApi) {
        if (apiModel) {
            this.subjectLine = apiModel.subjectLine;
            this.previewText = apiModel.previewText;
            this.fromName = apiModel.fromName;
            this.replyTo = apiModel.replyTo;
            this.replyMessageId = apiModel.replyMessageId;
            this.bodyHtml = apiModel.bodyHtml;
            this.bodyPlainText = apiModel.bodyPlainText;
            this.sendFrom = apiModel.sendFrom;
        }
    }

    toApiModel(): EmailAccountConnectorMessageApi{
        return {
            subjectLine:this.subjectLine,
            previewText:this.previewText,
            fromName:this.fromName,
            replyTo:this.replyTo,
            replyMessageId:this.replyMessageId,
            bodyHtml:this.bodyHtml,
            bodyPlainText:this.bodyPlainText,
            sendFrom:this.sendFrom
        } as EmailAccountConnectorMessageApi;
    }
}
